module.exports = __webpack_public_path__ + "img/k11.65372e09.jpg";